import View from './CookiePreferencesButton'
import { connect } from 'react-redux'
import { compose } from 'ramda'
import { toggleInfoDisplay } from '../../../store/modules/consentManagement'

const mapStateToProps = state => ({
  locale: state.router.locale,
})

const mapDispatchToProps = dispatch => ({
  toggleInfoDisplay: compose(dispatch, toggleInfoDisplay),
})

const CookiePreferencesButton = connect(
  mapStateToProps,
  mapDispatchToProps,
)(View)

export default CookiePreferencesButton
